const PICKER_WIDTH = 320;
const PICKER_HEIGHT = 380;
const VIEWPORT_PADDING = 8;

export interface EmojiPickerPosition {
  top: number;
  left: number;
  width: number;
  maxHeight: number;
}

export function getEmojiPickerPosition(
  anchorEl: HTMLElement,
): EmojiPickerPosition {
  const rect = anchorEl.getBoundingClientRect();
  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;

  const openBelow =
    spaceBelow >= PICKER_HEIGHT || spaceBelow >= spaceAbove;

  const maxHeight = Math.min(
    PICKER_HEIGHT,
    openBelow
      ? window.innerHeight - rect.bottom - VIEWPORT_PADDING * 2
      : rect.top - VIEWPORT_PADDING * 2,
  );

  let top = openBelow
    ? rect.bottom + VIEWPORT_PADDING
    : rect.top - maxHeight - VIEWPORT_PADDING;

  let left = rect.left;

  left = Math.max(
    VIEWPORT_PADDING,
    Math.min(left, window.innerWidth - PICKER_WIDTH - VIEWPORT_PADDING),
  );

  top = Math.max(
    VIEWPORT_PADDING,
    Math.min(top, window.innerHeight - maxHeight - VIEWPORT_PADDING),
  );

  return {
    top,
    left,
    width: PICKER_WIDTH,
    maxHeight: Math.max(maxHeight, 240),
  };
}
